jQuery(document).ready(function (jQuery) {
  // $("summary.header__menu-item, .mega-menu__content").hover(function () {
  //   $(this).parent("details").attr("open", "open");
  // });
  // $("summary.header__menu-item, .mega-menu__content").mouseleave(function () {
  //   $(this).parent("details").removeAttr("open");
  // });
  var items = document.querySelectorAll(".aico-accordion-container");
  for (var i = 0, len = items.length; i < len; i++) {
    (function (item) {
      const n = item.querySelector(".aico-accordion-toggle");
      const s = item.querySelector(".aico-accordion-opened-text");
      if (n && s) {
        n.addEventListener("click", () => {
          const isOpen = s.style.display === "block";
          s.style.display = isOpen ? "none" : "block";
          n.classList.toggle("open", !isOpen);
        });
      }
    })(items[i]);
  }

  // above will not work as that accordion is loading via JS
  // updated code below:

  $(document).on("click", ".aico-accordion-toggle, .aico-toggle-text", (e) => {
    const item = e.target.closest(".aico-accordion-container");
    const n = item.querySelector(".aico-accordion-toggle");
    const s = item.querySelector(".aico-accordion-opened-text");
    if (n && s) {
      const isOpen = s.style.display === "block";
      s.style.display = isOpen ? "none" : "block";
      n.classList.toggle("open", !isOpen);
    }
  });

  /*matchcenter page video*/
  const videos = document.querySelectorAll(".video");
  const circlePlayButtons = document.querySelectorAll(".play");

  function togglePlay(video, button) {
    if (video.paused || video.ended) {
      video.play();
    } else {
      video.pause();
    }
  }

  videos.forEach((video, index) => {
    const circlePlayButton = circlePlayButtons[index];
    if (circlePlayButton) {
      circlePlayButton.addEventListener("click", () =>
        togglePlay(video, circlePlayButton)
      );
    }
    if (video) {
      video.addEventListener("playing", () => {
        circlePlayButton.style.opacity = 0;
      });
      video.addEventListener("pause", () => {
        circlePlayButton.style.opacity = 1;
      });
    }
  });

  if($(".custom-slider").length > 0){
      $(".custom-slider").slick({
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,

    autoplaySpeed: 3000,
    arrows: true,
    prevArrow:
      "<button type='button' class='slick-prev pull-left'><i class='icon-arrow'></i></button>",
    nextArrow:
      "<button type='button' class='slick-next pull-right'><i class='icon-arrow'></i></button>",
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 400,
        settings: {
          arrows: true,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
  }  

  $("form.content_builder_form select")
    .focus(function () {
      $(this).parent().addClass("rotate");
    })
    .blur(function () {
      $(this).parent().removeClass("rotate");
    });

  $(document).on("click", ".data-table-items.row", function () {
    $(this).toggleClass("opened"); //Adds 'a', removes 'b' and vice versa
  });
});

function handlizer(str) {
  var handle = str
    .toLowerCase()
    .replace(/\s+/g, "-") // Replace spaces with -
    .replace(/[^\w\-]+/g, "") // Remove all non-word chars
    .replace(/\-\-+/g, "-") // Replace multiple - with single -
    .replace(/^-+/, "") // Trim - from start of text
    .replace(/-+$/, "");

  return handle;
}
const formatDate = (date, syear = "true") => {
  // const monthNames = ["Januar", "Februar", "März", "April", "Mai", "Juni","Juli", "August", "September", "Oktober", "November", "Dezember"];
  var newDate = date.split(" ");
  var newTime = newDate[1].split(":");

  date = newDate[0] + "T" + newDate[1] + "Z";
  var d = new Date(date);

  // var month = (monthNames[d.getUTCMonth()]).toString();
  if (currentLangIsocode == "fr") {
    var monthNames = [
      "Janvier",
      "Février",
      "Mars",
      "Avril",
      "Mai",
      "Juin",
      "Juillet",
      "Août",
      "Septembre",
      "Octobre",
      "Novembre",
      "Décembre",
    ];
    var days = [
      "Dimanche",
      "Lundi",
      "Mardi",
      "Mercredi",
      "Jeudi",
      "Vendredi",
      "Samedi",
    ];
    var month = monthNames[d.getUTCMonth()].toString();
    var dayname = days[d.getDay()];
  } else if (currentLangIsocode == "en") {
    var monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    var days = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    var month = monthNames[d.getUTCMonth()].toString();
    var dayname = days[d.getDay()];
  } else if (currentLangIsocode == "de") {
    var monthNames = [
      "Januar",
      "Februar",
      "März",
      "April",
      "Mai",
      "Juni",
      "Juli",
      "August",
      "September",
      "Oktober",
      "November",
      "Dezember",
    ];
    var days = [
      "Sonntag",
      "Montag",
      "Dienstag",
      "Mittwoch",
      "Donnerstag",
      "Freitag",
      "Samstag",
    ];
    var month = monthNames[d.getUTCMonth()].toString();
    var dayname = days[d.getDay()];
  }

  var day = d.getUTCDate().toString();
  var year = d.getUTCFullYear();
  var hour = d.getUTCHours();
  var minute = d.getUTCMinutes();
  // console.log("month", currentLangIsocode);
  if (month.length < 2) {
    month = "0" + month;
  }

  var min = "",
    h = "";
  if (day.length < 2) {
    day = day;
  }
  if (minute < 10) {
    min = 0;
  }
  if (hour < 10) {
    h = 0;
  }
  if (syear == "false") {
    year = newTime[0] + "." + newTime[1];
  }

  return day + ". " + month + " " + year;
};

const regularDate = (date) => {
  // var newDate = date.split(' ');
  // var newTime = newDate[1].split(':');

  // date = newDate[0]+'T'+newDate[1]+'Z';
  var d = new Date(date);

  var month = d.getUTCMonth() + 1;
  var day = d.getUTCDate();
  var year = d.getUTCFullYear();
  var hour = d.getUTCHours();
  var minute = d.getUTCMinutes();
  if (month.length < 2) {
    month = "0" + month;
  }

  if (day.length < 2) {
    day = "0" + day;
  }
  return day + "." + month + "." + year;
};

function formatDateString(date, format = "regular", time = "") {
  // var days = ["SO", "MO", "DI", "MI", "DO", "FR", "SA"];

  var newDate = date.split(" ");
  var newTime = newDate[1].split(":");

  date = newDate[0] + "T" + newDate[1] + "Z";
  var d = new Date(date);
  //console.log('currentLangIsocode',currentLangIsocode);
  
  if (currentLangIsocode == "fr") {
    var days = ["DIM", "LUN", "MAR", "MER", "JEU", "ven", "sam"];
    var dayname = days[d.getDay()];
  } else if (currentLangIsocode == "en") {
    var days = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
    var dayname = days[d.getDay()];
  } else if (currentLangIsocode == "de") {
    var days = ["SO", "MO", "DI", "MI", "DO", "FR", "SA"];
    var dayname = days[d.getDay()];
  }

  var month = d.getUTCMonth() + 1;
  var day = d.getUTCDate();
  // var dayname = days[d.getUTCDay()];
  var year = d.getUTCFullYear();
  var hour = d.getUTCHours();
  var minute = d.getUTCMinutes();

  if (month.length < 2) {
    month = "0" + month;
  }

  var min = "",
    h = "",
    dt = "",
    mt = "",
    tm = "";

  if (day.length < 2) {
    day = "0" + day;
  }
  if (minute < 10) {
    min = 0;
  }
  if (hour < 10) {
    h = 0;
  }
  if (day < 10) {
    dt = 0;
  }
  if (month < 10) {
    mt = 0;
  }
  if (time == "false") {
    tm = "";
  } else {
    // tm = ', '+h+hour+':'+min+minute;
    tm =
      ", <span class='break-mobile'>" +
      newTime[0] +
      "." +
      newTime[1] +
      " UHR</span>";
  }
  return dayname + ", " + dt + day + "." + mt + month + "." + year + tm;
}

const formatDateStringWithMonth = (date, format = "") => {
  var newDate = date.split(" ");
  var newTime = newDate[1].split(":");
  date = newDate[0] + "T" + newDate[1] + "Z";
  var d = new Date(date);

  if (currentLangIsocode == "fr") {
    const days = [
      "Dimanche",
      "Lundi",
      "Mardi",
      "Mercredi",
      "Jeudi",
      "Vendredi",
      "Samedi",
    ];
    const monthNames = [
      "Janvier",
      "Février",
      "Mars",
      "Avril",
      "Mai",
      "Juin",
      "Juillet",
      "Août",
      "Septembre",
      "Octobre",
      "Novembre",
      "Décembre",
    ];
    var month = monthNames[d.getUTCMonth()].toString();
    var dayname = days[d.getUTCDay()];
  } else if (currentLangIsocode == "en") {
    const days = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    var month = monthNames[d.getUTCMonth()].toString();
    var dayname = days[d.getUTCDay()];
  } else if (currentLangIsocode == "de") {
    const days = [
      "Sonntag",
      "Montag",
      "Dienstag",
      "Mittwoch",
      "Donnerstag",
      "Freitag",
      "Samstag",
    ];
    const monthNames = [
      "Januar",
      "Februar",
      "März",
      "April",
      "Mai",
      "Juni",
      "Juli",
      "August",
      "September",
      "Oktober",
      "November",
      "Dezember",
    ];
    var month = monthNames[d.getUTCMonth()].toString();
    var dayname = days[d.getUTCDay()];
  }

  //console.log("lang",currentLangIsocode,d.getUTCMonth());

  var day = d.getUTCDate();
  var year = d.getUTCFullYear();
  var hour = d.getUTCHours();
  var minute = d.getUTCMinutes();
  if (month.length < 2) {
    month = "0" + month;
  }

  var min = "",
    h = "",
    dt = "";

  if (day.length < 2) {
    day = "0" + day;
  }
  if (minute < 10) {
    min = 0;
  }
  if (hour < 10) {
    h = 0;
  }
  if (day < 10) {
    dt = 0;
  }
  if (newTime[0] == "00" && newTime[1] == "00") {
    var timeString = " (noch nicht def. fixiert)";
  } else {
    var timeString = ", " + newTime[0] + "." + newTime[1];
  }
  return dayname + ", " + dt + day + ". " + month + " " + year + timeString;
};

const formatDateStringforfuturematch = (date, format = "") => {
  // const days = ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"];
  // const monthNames = ["Januar", "Februar", "März", "April", "Mai", "Juni","Juli", "August", "September", "Oktober", "November", "Dezember"];

  var isValid = isValidDate(date.toString());
  if (isValid == false) {
    var d = new Date(date);
  } else {
    var d = date;
  }
  //console.log(isValid,d);

  // var month = (monthNames[d.getMonth()]).toString();
  var day = d.getDate();
  // var dayname = days[d.getDay()];
  var year = d.getFullYear();
  var hour = d.getHours();
  var minute = d.getMinutes();

  if (currentLangIsocode == "fr") {
    const monthNames = [
      "Janvier",
      "Février",
      "Mars",
      "Avril",
      "Mai",
      "Juin",
      "Juillet",
      "Août",
      "Septembre",
      "Octobre",
      "Novembre",
      "Décembre",
    ];
    const days = [
      "Dimanche",
      "Lundi",
      "Mardi",
      "Mercredi",
      "Jeudi",
      "Vendredi",
      "Samedi",
    ];
    var month = monthNames[d.getUTCMonth()].toString();
    var dayname = days[d.getDay()];
  } else if (currentLangIsocode == "en") {
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const days = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    var month = monthNames[d.getUTCMonth()].toString();
    var dayname = days[d.getDay()];
  } else if (currentLangIsocode == "de") {
    const monthNames = [
      "Januar",
      "Februar",
      "März",
      "April",
      "Mai",
      "Juni",
      "Juli",
      "August",
      "September",
      "Oktober",
      "November",
      "Dezember",
    ];
    const days = [
      "Sonntag",
      "Montag",
      "Dienstag",
      "Mittwoch",
      "Donnerstag",
      "Freitag",
      "Samstag",
    ];
    var month = monthNames[d.getUTCMonth()].toString();
    var dayname = days[d.getDay()];
  }
  if (month.length < 2) {
    month = "0" + month;
  }

  var min = "",
    h = "",
    dt = "";

  if (day.length < 2) {
    day = "0" + day;
  }
  if (minute < 10) {
    min = 0;
  }
  if (hour < 10) {
    h = 0;
  }
  if (day < 10) {
    dt = 0;
  }
  return (
    dayname +
    ", " +
    dt +
    day +
    ". " +
    month +
    " " +
    year +
    ", " +
    h +
    hour +
    "." +
    min +
    minute
  );
};

const formatDateStringforUnconfirmedMatch = (dateString) => {
  const date = new Date(dateString);

  if (isNaN(date)) {
    throw new Error("Invalid date format");
  }

  const day = String(date.getDate()).padStart(2, "0");
  const nextDay = String(date.getDate() + 1).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const year = date.getFullYear();

  return `${day}./${nextDay}.${month}.${year}, <span class="not-confirmed">NICHT BESTÄTIGT</span>`;
}

function isValidDate(s) {
  var bits = s.split("/");
  var d = new Date(bits[2] + "/" + bits[1] + "/" + bits[0]);
  return !!(d && d.getMonth() + 1 == bits[1] && d.getDate() == Number(bits[0]));
}

function addDays(theDate, days) {
  return new Date(theDate.getTime() + days * 24 * 60 * 60 * 1000);
}

function changeTimeZone(date, timeZone) {
  if (typeof date === "string") {
    return new Date(
      new Date(date).toLocaleString("en-US", {
        timeZone,
      })
    );
  }

  return new Date(
    date.toLocaleString("en-US", {
      timeZone,
    })
  );
}

const formatDateStringforsflmatch = (date, format = "") => {
  const d = changeTimeZone(new Date(date), "Europe/Zurich");

  //var month = (monthNames[d.getMonth()]).toString();
  var day = d.getDate();

  var year = d.getFullYear();
  var hour = d.getHours();
  var minute = d.getMinutes();

  if (currentLangIsocode == "fr") {
    const monthNames = [
      "Janvier",
      "Février",
      "Mars",
      "Avril",
      "Mai",
      "Juin",
      "Juillet",
      "Août",
      "Septembre",
      "Octobre",
      "Novembre",
      "Décembre",
    ];
    const days = [
      "Dimanche",
      "Lundi",
      "Mardi",
      "Mercredi",
      "Jeudi",
      "Vendredi",
      "Samedi",
    ];
    var month = monthNames[d.getUTCMonth()].toString();
    var dayname = days[d.getDay()];
  } else if (currentLangIsocode == "en") {
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const days = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    var month = monthNames[d.getUTCMonth()].toString();
    var dayname = days[d.getDay()];
  } else if (currentLangIsocode == "de") {
    const monthNames = [
      "Januar",
      "Februar",
      "März",
      "April",
      "Mai",
      "Juni",
      "Juli",
      "August",
      "September",
      "Oktober",
      "November",
      "Dezember",
    ];
    const days = [
      "Sonntag",
      "Montag",
      "Dienstag",
      "Mittwoch",
      "Donnerstag",
      "Freitag",
      "Samstag",
    ];
    var month = monthNames[d.getUTCMonth()].toString();
    var dayname = days[d.getDay()];
  }

  if (month.length < 2) {
    month = "0" + month;
  }

  var min = "",
    h = "",
    dt = "";

  if (day.length < 2) {
    day = "0" + day;
  }
  if (minute < 10) {
    min = 0;
  }
  if (hour < 10) {
    h = 0;
  }
  if (day < 10) {
    dt = 0;
  }
  return (
    '<span class="date_date">' +
    dayname +
    ", " +
    dt +
    day +
    ". " +
    month +
    " " +
    year +
    '</span><span class="date_time">' +
    h +
    hour +
    "." +
    min +
    minute +
    "</span>"
  );
};

const formatDateStringfor_match = (date, format = "") => {
  const d = new Date(date);

  var day = d.getDate();

  var year = d.getFullYear();
  var hour = d.getHours();
  var minute = d.getMinutes();

  if (currentLangIsocode == "fr") {
    const monthNames = [
      "Janvier",
      "Février",
      "Mars",
      "Avril",
      "Mai",
      "Juin",
      "Juillet",
      "Août",
      "Septembre",
      "Octobre",
      "Novembre",
      "Décembre",
    ];
    const days = [
      "Dimanche",
      "Lundi",
      "Mardi",
      "Mercredi",
      "Jeudi",
      "Vendredi",
      "Samedi",
    ];
    var month = monthNames[d.getUTCMonth()].toString();
    var dayname = days[d.getDay()];
  } else if (currentLangIsocode == "en") {
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const days = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    var month = monthNames[d.getUTCMonth()].toString();
    var dayname = days[d.getDay()];
  } else if (currentLangIsocode == "de") {
    const monthNames = [
      "Januar",
      "Februar",
      "März",
      "April",
      "Mai",
      "Juni",
      "Juli",
      "August",
      "September",
      "Oktober",
      "November",
      "Dezember",
    ];
    const days = [
      "Sonntag",
      "Montag",
      "Dienstag",
      "Mittwoch",
      "Donnerstag",
      "Freitag",
      "Samstag",
    ];
    var month = monthNames[d.getUTCMonth()].toString();
    var dayname = days[d.getDay()];
  }

  if (month.length < 2) {
    month = "0" + month;
  }

  var min = "",
    h = "",
    dt = "";

  if (day.length < 2) {
    day = "0" + day;
  }
  if (minute < 10) {
    min = 0;
  }
  if (hour < 10) {
    h = 0;
  }
  if (day < 10) {
    dt = 0;
  }
  return (
    '<span class="date_date">' +
    dayname +
    ", " +
    dt +
    day +
    ". " +
    month +
    " " +
    year +
    '</span><span class="date_time">' +
    h +
    hour +
    "." +
    min +
    minute +
    "</span>"
  );
};

const formatDateStringforgameday = (date, format = "") => {
  // const days = ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"];
  const monthNames = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
  ];

  var d = new Date(date);
  var month = monthNames[d.getUTCMonth()].toString();
  var day = d.getUTCDate();
  // var dayname = days[d.getUTCDay()];
  var year = d.getUTCFullYear();
  var hour = d.getUTCHours();
  var minute = d.getUTCMinutes();

  if (currentLangIsocode == "fr") {
    const days = [
      "Dimanche",
      "Lundi",
      "Mardi",
      "Mercredi",
      "Jeudi",
      "Vendredi",
      "Samedi",
    ];
    var dayname = days[d.getDay()];
  } else if (currentLangIsocode == "en") {
    const days = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    var dayname = days[d.getDay()];
  } else if (currentLangIsocode == "de") {
    const days = [
      "Sonntag",
      "Montag",
      "Dienstag",
      "Mittwoch",
      "Donnerstag",
      "Freitag",
      "Samstag",
    ];
    var dayname = days[d.getDay()];
  }

  var min = "",
    h = "",
    dt = "";

  if (minute < 10) {
    min = 0;
  }
  if (hour < 10) {
    h = 0;
  }
  if (day < 10) {
    dt = 0;
  }
  return dayname + " | " + dt + day + "." + month + "." + year;
};

const monthyear = (date) => {
  var newDate = date.split(" ");
  var newTime = newDate[1].split(":");
  date = newDate[0] + "T" + newDate[1] + "Z";
  var d = new Date(date);
  var year = d.getUTCFullYear();

  if (currentLangIsocode == "fr") {
    const monthNames = [
      "Janvier",
      "Février",
      "Mars",
      "Avril",
      "Mai",
      "Juin",
      "Juillet",
      "Août",
      "Septembre",
      "Octobre",
      "Novembre",
      "Décembre",
    ];
    var month = monthNames[d.getUTCMonth()].toString();
  } else if (currentLangIsocode == "en") {
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    var month = monthNames[d.getUTCMonth()].toString();
  } else if (currentLangIsocode == "de") {
    const monthNames = [
      "Januar",
      "Februar",
      "März",
      "April",
      "Mai",
      "Juni",
      "Juli",
      "August",
      "September",
      "Oktober",
      "November",
      "Dezember",
    ];
    var month = monthNames[d.getUTCMonth()].toString();
  }

  if (month.length < 2) {
    month = "0" + month;
  }
  return month + " " + year;
};

function getFormatedDate(dt) {
  var tempDate = new Date(dt);
  var dy = tempDate.getDate();
  var m = tempDate.getMonth() + 1;

  if (dy < 9) {
    dy = "0" + dy;
  }
  if (m < 9) {
    m = "0" + m;
  }
  var formattedDate = [dy, m, tempDate.getFullYear()].join("/");
  return formattedDate;
}

$(document).ready(function () {
  function updateWidthMinusWidth() {
    let totalWidth = 0;

    // Calculate total width of all li elements
    $(
      ".header--middle-left .header__inline-menu > .list-menu .header__menu-item"
    ).each(function () {
      totalWidth += $(this).outerWidth(true); // Include margin
    });

    // Get the width of the ul and logo elements
    let ulWidth = $(
      ".header--middle-left .header__inline-menu > .list-menu"
    ).outerWidth(true); // Include margin
    let logoWidth = $(".header__heading-logo").outerWidth(true); // Include margin

    // Calculate the difference
    let widthMinusWidth = ulWidth - totalWidth + logoWidth;

    // Set the CSS variable
    $(".mega-menu__content .menu-title-wrapper").css(
      "--width-minus-height",
      widthMinusWidth + "px"
    );
    $(".mega-menu__content .mega-menu__list").css(
      "--width-minus-height",
      widthMinusWidth + "px"
    );
  }

  // Run on document ready and window resize
  updateWidthMinusWidth();
  $(window).resize(updateWidthMinusWidth);

  $(document).on(
    "click",
    ".page--stadionbesuch .contentBuilder_v2_wrap .only-text-row .gjs-cell-item .content-col .read-more",
    function () {
      // Close all other .read-more-text divs
      $(".read-more-text")
        .not($(this).siblings(".desc").find(".read-more-text"))
        .slideUp(300);
      $(".content-col .read-more").not(this).removeClass("active");

      // Toggle the selected .read-more-text div
      $(this).siblings(".desc").find(".read-more-text").slideToggle(300);
      $(this).toggleClass("active");
    }
  );
});
// Slide animation - Devinder
document.addEventListener("DOMContentLoaded", function () {
  const collageItems = document.querySelectorAll(".collage__item");

  function isElementInViewport1(el) {
    const rect = el.getBoundingClientRect();
    return (
      rect.top <= (window.innerHeight || document.documentElement.clientHeight)
    );
  }

  function checkVisibility1() {
    let allAnimated = true; // Flag to track if all items are animated

    collageItems.forEach((item) => {
      if (isElementInViewport1(item) && !item.classList.contains("animate")) {
        item.classList.add("animate"); // Start animation
        // Optional: Log to verify
        // console.log("Animate class added to:", item);
      }

      // If any item hasn't been animated yet, set the flag to false
      if (!item.classList.contains("animate")) {
        allAnimated = false;
      }
    });

    // Remove the scroll event listener if all items have been animated
    if (allAnimated) {
      window.removeEventListener("scroll", checkVisibility1);
    }
  }

  window.addEventListener("scroll", checkVisibility1);
  checkVisibility1(); // Initial check in case elements are already in view
});

document.addEventListener("DOMContentLoaded", () => {
  // Reusable helper functions
  function isElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
      rect.top <= (window.innerHeight || document.documentElement.clientHeight)
    );
  }

  // Handle autoplay for team video
  if (window.location.href.includes("/teams/")) {
    subscribe("team-loaded", () => {
      autoPlayTeamVideo(".page--teams .squad-portrait");
    });
  }

  function onIntersection(elements, observer) {
    elements.forEach((element, index) => {
      let videoElement = element.target.querySelector("video");
      if (element.isIntersecting) {
        videoElement?.setAttribute("autoplay", true);
        videoElement?.play();
        observer.unobserve(element.target);
      } else {
        videoElement?.removeAttribute("autoplay");
      }
    });
  }

  function autoPlayTeamVideo(selector) {
    // console.log('loaded');
    let elements = document.querySelectorAll(selector);
    const intersect_observer = new IntersectionObserver(onIntersection);
    elements.forEach((element) => intersect_observer.observe(element));
  }

  function handleVisibilityCheck(elements) {
    let allAnimated = false;

    function checkVisibility() {
      allAnimated = true; // Assume all elements are animated

      elements.forEach((el, index) => {
        if (isElementInViewport(el) && !el.classList.contains("animate")) {
          const delay = index * 0.1; // 0.2s interval between each slide
          el.style.animationDelay = `${delay}s`;
          el.classList.add("animate");
        }

        if (!el.classList.contains("animate")) {
          allAnimated = false;
        }
      });

      if (allAnimated) {
        window.removeEventListener("scroll", checkVisibility);
      }
    }

    // Attach scroll listener and perform an initial check
    window.addEventListener("scroll", checkVisibility);
    checkVisibility();
  }

  // Function to initialize animations for a specific selector
  function initAnimations(selector) {
    const elements = document.querySelectorAll(selector);
    if (elements.length > 0) {
      handleVisibilityCheck(elements);
    }
  }

  function observeElements(selector, onVisibleCallback) {
    const observer = new MutationObserver(() => {
      const elements = document.querySelectorAll(selector);
      if (elements.length > 0) {
        observer.disconnect(); // Stop observing once elements are found
        onVisibleCallback(elements);
      }
    });

    // Observe for changes in the DOM
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // Observe dynamically added content
  function observeDynamicContent(selector) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1 && node.matches(selector)) {
            // Initialize animation for the new node
            // initAnimations(selector);
          }
        });
      });
    });

    // Observe for changes in the DOM
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // Handle animations for different sections
  if ($(".content-builder-grid > a").length > 0) {
    observeElements(".content-builder-grid > a", (elements) => {
      handleVisibilityCheck(elements);
    });
  }

  // observeDynamicContent(".content-builder-grid > a");
  observeDynamicContent(".social_feed_wrap .collage__item");

  // Dropdown toggle logic
  $(".dropdown-wrapper").click(function () {
    $(this).toggleClass("opened");
  });

  document.addEventListener("click", (e) => {
    document
      .querySelectorAll(".dropdown-wrapper.open, .dropdown-wrapper.opened")
      .forEach((dropdown) => {
        if (!dropdown.contains(e.target)) {
          dropdown.classList.remove("open", "opened");
        }
      });
  });
});

window.setCookie = function (cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toGMTString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
};

window.getCookie = function (cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var cookieArray = decodedCookie.split(";");
  for (var i = 0; i < cookieArray.length; i++) {
    var cookieItem = cookieArray[i];
    while (cookieItem.charAt(0) === " ") {
      cookieItem = cookieItem.substring(1);
    }
    if (cookieItem.indexOf(name) === 0) {
      return cookieItem.substring(name.length, cookieItem.length);
    }
  }
  return "";
};

$(document).ready(function () {
  // scrollSticky();
  function scrollSticky() {
    $(".template--page main").each(function () {
      var divBottom =
        $(this).offset().top + $(this).outerHeight() - $(window).scrollTop();

      if (divBottom <= $(window).height()) {
        $(this).addClass("bottom-zero");
      } else {
        $(this).removeClass("bottom-zero");
      }
    });
  }
  $(window).on("scroll", function () {
    scrollSticky();
  });

  $(document).on(
    "click",
    ".social_feed_wrap .has_mp4_video.video_playing .media",
    function () {
      const video = $(this).find("video").get(0); // Get the native DOM video element
      const playButton = $(this).find(".icon-play");
      const parentItem = playButton.closest('.has_mp4_video');
      
      if (!video) {
        console.error("Video element not found");
        return;
      }

      // console.log('clicked');
      if (video.paused) {
        video.play();
        playButton.hide(); // Hide the play button when video is playing

        if (parentItem && $(window).width() >= 540) {
          $(".insta-heading", parentItem).addClass("hidden");
        }
      } else {
        video.pause();
        $(parentItem).removeClass('video_playing');
        playButton.show(); // Show the play button when video is paused
        if (parentItem && $(window).width() >= 540) {
          $(".insta-heading", parentItem).removeClass("hidden");
        }
      }
    }
  );
// single new in related new show as per contetn height js start
  // Function to adjust news section heights
  function newssectionHeights() {
    if ($(window).width() > 1000) {
      const newsContent = $(".news-content-wrapper").find(".blog_wrapper");
      const relatedNewsCol = $(".news-content-wrapper .related-news").find(
        ".content-container"
      );

      // Get element heights
      const newsContentHeight = newsContent.outerHeight();
      const relatedNewsColHeight = relatedNewsCol.outerHeight();
      const relatedNewsColLength = relatedNewsCol.length;

      // Hide all content containers initially
      relatedNewsCol.hide();

      // Calculate how many containers should be shown
      const numToShow = Math.floor(newsContentHeight / relatedNewsColHeight);

      // Show the required number of content containers
      relatedNewsCol.slice(0, numToShow).show();
    } else {
      // If window width is less than or equal to 1000, show all content containers
      $(".news-content-wrapper .related-news .content-container").show();
    }
  }

  // Initial call
  newssectionHeights();

  // Run function after a delay (1000ms)
  $(window).on("load", () => {
    setTimeout(() => {
      newssectionHeights();
    }, 1000);
  });

  // Add debounce for resize events
  let resizeNewssection;
  $(window).on("resize", () => {
    clearTimeout(resizeNewssection);
    resizeNewssection = setTimeout(() => {
      newssectionHeights();
    }, 500); // Adjust delay time as needed
  });

  // Run the function after AJAX call is completed
  $(document).ajaxComplete(() => {
    newssectionHeights();
  });
// single new in related new show as per contetn height js end   
});

$(document).ready(function () {
  function videourlScroll() {
    // Extract the ID from the URL
    var hash = window.location.hash;
    var windowHeight = $(window).height(); // Get window height
    
    // Check if there's a hash in the URL
    if (hash) {
        // Scroll to the section smoothly
        $('html, body').animate({
            scrollTop: $(hash).offset().top + (windowHeight / 1) + 150
        }, 1000); // Adjust the duration as needed (1000ms = 1s)
    }
  }
    $(window).on("load", () => {
    setTimeout(() => {
      videourlScroll();
    }, 300);
  });

  const images = $(".aico-image-gallery a");
  const readMoreLink = $(".read-more-link");
    $(".aico-image-gallery a").fancybox({
            buttons: [
                "thumbs",   // Enables thumbnail grid view
                // "zoom",
                "fullScreen",
                "close"
            ],
            loop: false,
            protect: true,
            thumbs: {
                autoStart: true,  // Show thumbnails automatically
                axis: "y"         // Horizontal thumbnails
            },
            transitionEffect: "fade" // Smooth transition effect
        });
  function updateVisibility() {
    let visibleCount = $(window).width() < 750 ? 4 : 6;
    images.each(function (index) {
     $(this).toggleClass("hidden", index >= visibleCount);
    });
    readMoreLink.toggle(images.length > visibleCount);
  }
  
  readMoreLink.on("click", function (event) {
    event.preventDefault();
    if (readMoreLink.text() === "Mehr Bilder") {
     images.removeClass("hidden");
     readMoreLink.text("Weniger Bilder");
    } else {
     updateVisibility();
     readMoreLink.text("Mehr Bilder");
    }
  });
  
  updateVisibility();
  $(window).on("resize", updateVisibility);





  // to bind custom play-pause actions to youtube iframe videos
  let ytFound;
  function bindYTVideos () {
    if (!YT || YT === "undefined") {
      ytFound = setInterval(() => {
        bindYTVideos();
      }, 500)
    } else {
     clearInterval(ytFound);
    }
    let ytPlayers = {};
    window.onYouTubeIframeAPIReady = function () {
      console.log("yt ready");
      document.querySelectorAll("iframe.yt-player").forEach((iframe) => {
        console.log("iframe", iframe);
        let playerId = iframe.id;
        console.log("yt ready!!", playerId);
        
        ytPlayers[playerId] = new YT.Player(playerId, {
          events: {
            onStateChange: onYTPlayerStateChange,
          },
        });
      });
     // clearInterval(ytFound);
    }
    
    // force initialize 
    if (YT) {
      onYouTubeIframeAPIReady();
    }
    
    $(document).on("click", ".player-play-btn", (e) => {
      console.log("dadada", ytPlayers);
      let container = $(e.target).closest('.video-container');
      let player = $("iframe.yt-player", container).attr("id");
      ytPlayers[player].playVideo();
    });
    function onYTPlayerStateChange(e) {
      let container = $("#" + e.target.g.id).closest('.video-container');
      $(".page-video--overlay", container).toggleClass("hidden", e.data !== 2)
    }
  }
  bindYTVideos();
});



// ---------------------------------
function setMaxHeight(containerSelector, elementSelector, cssVariableName) {
  const elements = $(`${containerSelector} ${elementSelector}`);
  let maxHeight = 0;

  // Reset any existing height to get accurate measurement
  $(containerSelector).css(cssVariableName, 'auto');

  elements.each((index, el) => {
    const height = $(el).outerHeight(true);
    maxHeight = Math.max(maxHeight, height);
  });

  $(containerSelector).css(cssVariableName, `${maxHeight}px`);
}

function updateHeights() {
  setMaxHeight('.aico-address-teaser-text-block', '.aico-title', '--title-max-height');
  setMaxHeight('.aico-tile-content-wrapper .aico-tile-block-wrapper', '.aico-tile-subtitle', '--subtitle-max-height');
}

// Debounce function to limit rapid firing on resize
let resizeTimeout;
$(window).on('resize', () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    updateHeights();
  }, 100);
});

$(document).ready(() => {
  updateHeights();
});

// ---------------------------------